import React from 'react';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { useBranding } from '../context/BrandingContext';

export default function PublicHelp() {
    const { t } = useTranslation();
    const { appName, supportEmail, supportPhone } = useBranding();
    const name = appName || 'ChessDesk';

    return (
        <div className="min-h-screen bg-gray-50 py-10 px-4">
            <div className="mx-auto max-w-2xl bg-white rounded-2xl shadow-sm border border-gray-100 px-8 py-10 space-y-6">
                <div>
                    <Link to="/login" className="text-xs text-primary-600 hover:underline">{t('publicHelp.backToLogin')}</Link>
                    <h1 className="text-2xl font-bold text-gray-900 mt-2">{t('publicHelp.title')}</h1>
                    <p className="text-sm text-gray-500 mt-1">{t('publicHelp.subtitle', { name })}</p>
                </div>

                <section className="space-y-2">
                    <h2 className="text-base font-semibold text-gray-900">{t('publicHelp.signingIn')}</h2>
                    <p className="text-sm text-gray-600 leading-relaxed">
                        {t('publicHelp.signingInBody')}
                    </p>
                </section>

                <section className="space-y-2">
                    <h2 className="text-base font-semibold text-gray-900">{t('publicHelp.forgotPassword')}</h2>
                    <p className="text-sm text-gray-600 leading-relaxed">
                        <Trans
                            i18nKey="publicHelp.forgotPasswordBody"
                            components={{
                                1: <Link to="/forgot-password" className="text-primary-600 hover:underline" />,
                            }}
                        />
                    </p>
                </section>

                {(supportEmail || supportPhone) && (
                    <section className="space-y-2">
                        <h2 className="text-base font-semibold text-gray-900">{t('publicHelp.contactAcademy')}</h2>
                        <p className="text-sm text-gray-600 leading-relaxed">
                            {t('publicHelp.contactAcademyBody')}
                        </p>
                        <ul className="text-sm text-gray-700 space-y-1">
                            {supportEmail && (
                                <li>
                                    {t('publicHelp.email')}{' '}
                                    <a href={`mailto:${supportEmail}`} className="text-primary-600 hover:underline">
                                        {supportEmail}
                                    </a>
                                </li>
                            )}
                            {supportPhone && (
                                <li>
                                    {t('publicHelp.phone')}{' '}
                                    <a href={`tel:${supportPhone.replace(/\s+/g, '')}`} className="text-primary-600 hover:underline">
                                        {supportPhone}
                                    </a>
                                </li>
                            )}
                        </ul>
                    </section>
                )}

                <section className="space-y-2">
                    <h2 className="text-base font-semibold text-gray-900">{t('publicHelp.privacy')}</h2>
                    <p className="text-sm text-gray-600 leading-relaxed">
                        <Trans
                            i18nKey="publicHelp.privacyBody"
                            components={{
                                1: <Link to="/privacy-policy" className="text-primary-600 hover:underline" />,
                            }}
                        />
                    </p>
                </section>
            </div>
        </div>
    );
}
